<template>
  <a-drawer
    :visible="visible"
    title="药品说明书"
    placement="right"
    :width="500"
    :maskClosable="false"
    :bodyStyle="{ height: 'calc(100vh - 55px)', padding: 0 }"
    @close="emit('close')"
  >
    <div class="leaflet-drawer">
      <iframe v-if="leafletUrl" class="leaflet-iframe" :src="leafletUrl" frameborder="0"></iframe>
      <a-empty v-else description="暂无说明书" />
    </div>
  </a-drawer>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  doctorId: {
    type: [String, Number],
    default: ''
  },
  skuCode: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close'])

const leafletUrl = computed(() => {
  if (!props.doctorId || !props.skuCode) return ''
  const baseUrl = process.env.VUE_APP_GOODS_INFO_URL || ''
  if (!baseUrl) return ''
  return `${baseUrl}/vue/dist/#/origin/goodsInfo?doctorId=${props.doctorId}&skuCode=${props.skuCode}`
})
</script>

<style scoped lang="scss">
.leaflet-drawer {
  height: 100%;
}

.leaflet-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

::v-deep(.ant-drawer-body) {
  height: 100%;
  padding: 0;
}
</style>
